export const data = {
  buttons: [
    {
      label: 'Repair',
      id: 'repair',
    },
    {
      label: 'Replacement',
      id: 'replacement',
    },
    {
      label: 'Refund',
      id: 'refund',
    },
  ],
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/5e64c8f9579d-tooliconquestion.jpg',
  },
  title: 'What do you want the seller to do?',
}
